<div id="" class="site-fullscreen site-sticky">
    <app-header></app-header>
    <app-page-title *ngIf="PageTitles !== ''"></app-page-title>
    <app-news-marquee *ngIf="PageTitles !== ''"></app-news-marquee>
    <router-outlet></router-outlet>
    <app-footer></app-footer>
</div>